import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
// import RaisedButton from 'material-ui/RaisedButton';
import TextField from "material-ui/TextField";
import {
  getCabinPassengerFieldMessage,
  getModalContentValidity
} from "./selectors";

/**
 * A modal dialog can only be closed by selecting one of the actions.
 */
class Modal extends React.Component {
  state = {
    open: false
  };

  handleOpen = () => {
    document.activeElement.blur(); // Blur text elem that was clicked
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  _styles = {
    inputStyle: {
      // color: "white",
      // color: "grey",
      color: "#66615b",
      fontFamily: '"Montserrat", sans-serif'
    },
    floatingLabelStyle: {
      // color: "white"
      // color: "grey"
      color: "#66615b"
    },
    underlineFocusStyle: {
      // borderColor: "#ffa500"
      borderColor: "none"
    },
    underlineStyle: {
      // borderColor: "grey"
      borderColor: "#66615b"
    },
    // header: {
    //   color: "white",
    //   textAlign: "center",
    //   letterSpacing: "1px"
    // },
    popover: {
      // width: '90%', // This should be for mobile only
      // maxWidth: '350px'
      // width: '300px'
    }
  };

  render() {
    const {
      passenger_cabin_text_val,
      modalContentValidity,
      content
    } = this.props;

    const actions = [
      <FlatButton
        label="Done"
        primary
        disabled={!modalContentValidity.isModalContentValid}
        onClick={this.handleClose}
      />
    ];

    return (
      <div>
        {/* <RaisedButton label="Modal Dialog" onClick={this.handleOpen} /> */}

        <TextField
          name={"passenger_cabin_text"}
          onClick={this.handleOpen}
          // onChange={this.handleInputChange}
          // onFocus={this.openDropDownMenu}
          fullWidth
          value={passenger_cabin_text_val}
          floatingLabelText="Passenger"
          inputStyle={this._styles.inputStyle}
          floatingLabelStyle={this._styles.floatingLabelStyle}
          underlineFocusStyle={this._styles.underlineFocusStyle}
          underlineStyle={this._styles.underlineStyle}
        />

        <Dialog
          // title="Dialog With Actions"
          // contentStyle={{ width: '40%',  maxWidth: 'none'}}
          actions={actions}
          modal
          open={this.state.open}
        >
          {/* Only actions can close this dialog. */}

          {content}
        </Dialog>
      </div>
    );
  }
}

Modal = reduxForm({
  form: "passengerCabinDropDownMenuContent"
})(Modal);

function mapStateToProps(state) {
  return {
    passenger_cabin_text_val: getCabinPassengerFieldMessage(state),
    modalContentValidity: getModalContentValidity(state)
  };
}

export default connect(mapStateToProps)(Modal);



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/PassengerCabinField/ModalTriggerTextField.js